import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { VideoPlayerComponent } from '../../video-player.component';
import { PopoverModule } from '@ngx-popovers/popover';
import { Arrow, MiddlewareList } from '@ngx-popovers/core';
import { offset } from '@floating-ui/dom';


@Component({
  selector: 'app-quality-control-selector',
  templateUrl: 'quality-control-selector.component.html',
  styleUrls: ['quality-control-selector.component.scss'],
  standalone: true,
  imports: [CommonModule, PopoverModule, Arrow]
})
export class QualityControlSelectorComponent implements OnChanges {

  @Input() videoPlayerComponent: VideoPlayerComponent
  @Input() bindTo: string | HTMLElement | undefined;


  @Input() isMouseHovering: boolean = false;

  popovermiddleware: MiddlewareList = []

  private timeOut: NodeJS.Timeout = null;

  constructor() { }


  ngOnChanges(changes: SimpleChanges) {
    this.popovermiddleware = [
      offset(
        {
          crossAxis: this.videoPlayerComponent.isFullScreen() ? -20 : 20,
        }
      )
    ]

    // Replicamos la lógica que estaba en 'notify()'
    // Escuchamos los cambios en 'isMouseHovering'
    if (changes['isMouseHovering']) {
      const isHovering = changes['isMouseHovering'].currentValue;

      if (isHovering) {
        clearTimeout(this.timeOut);
      } else {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
            document.body.click();
          }
          , 1000);
      }
    }
  }

  isMouseHoveringVideo(): boolean {
    return this.isMouseHovering;
  }


}
